import * as Namespaces from "./namespaces";

const locales = {
	[Namespaces.PAGE_LOGIN]: {
		el: {
			'Connection': 'Σύνδεση',
			'SNF Grant Portal': 'Πύλη Δωρεών ΙΣΝ',
			'Enter your username': 'Εισάγετε το όνομα χρήστη',
			'Password': 'Συνθηματικό',
			'Login': 'Είσοδος',
			'Required': 'Απαιτείται',
			'Forgot password? Click here.': 'Ξεχάσατε τον κωδικό σας; Πατήστε εδώ.',
			'Cancel': 'Ακύρωση',
			'Password reset': 'Ανάκτηση Κωδικού',
			'reset_password': 'Για να δηλώσετε νέο κωδικό, παρακαλώ εισάγετε το email σας εδώ. Θα λάβετε στο email σας έναν εξαψήφιο κωδικό. <br/> Χρησιμοποιείστε τον εξαψήφιο κωδικό για να δηλώσετε τον νέο κωδικό σας.',
			"Not Found": "Το email που καταχωρήθηκε δεν υπάρχει.",
			'reset_success': 'Ο κωδικός σας έχει αλλάξει επιτυχώς. Προχωρήστε στη σύνδεση με τον νέο κωδικό σας.',
			'request_new_pass_success': 'Ο εξαψήφιος κωδικός έχει αποσταλεί επιτυχώς στο email σας. Αν δεν βλέπετε το email, παρακαλώ ελέγξτε τους φακέλους των SPAM ή JUNK emails.',
			'Password must be between 7-16 latin characters and contain at least 3 of the following. -Upper case character -Lower case character -Numeric digit -Special character': 'Ο κωδικός πρόσβασης πρέπει να αποτελείται από 7-16 λατινικούς χαρακτήρες και να περιέχει τουλάχιστον 3 από τα ακόλουθα. -Κεφάλαιο -Πεζό χαρακτήρα -Αριθμητικό ψηφίο -Ειδικός χαρακτήρας',
			'Passwords must match': 'Οι κωδικοί πρέπει να ταιριάζουν',
			'Six digit code': 'Εξαψήφιος κωδικός',
			'New password': 'Νέος κωδικός',
			'Confirm password': 'Επαλήθευση κωδικού',
			'Submit New Password': 'Υποβολή Νέου Κωδικού',
			'Send 6 Digit Code': 'Αποστολή Εξαψήφιου Κωδικού',
			'Connection to API failed!': 'Η επικοινωνία με το API απέτυχε!',
			'Insert a valid email': 'Εισάγετε ένα έγκυρο email',
			'Wrong 6 digit password!': 'Μη έγκυρος ή ληγμένος εξαψήφιος κωδικός!',
			'Enter your email': 'Εισαγωγή email',
			'msg.login_notfound': 'Λανθασμένα στοιχεία πρόσβασης',
			'An error occurred!': 'Παρουσιάστηκε σφάλμα!',
			'Invalid email': 'Μη έγκυρο email',
			'New Account': 'Νέος Λογαριασμός',
			'Change Password': 'Αλλαγή Συνθηματικού',
			'SNF Grant Portal | Change Password': 'Πύλη Δωρεών ΙΣΝ | Αλλαγή Συνθηματικού',
			'Continue': 'Συνέχεια',
			'Home': 'Αρχική',
			'SNF Grant Portal | Account Registration': 'Πύλη Δωρεών ΙΣΝ | Εγγραφή και απόκτηση πρόσβασης',
			'SNF Grant Portal | Registration Process | Mobile Phone and Email Verification': 'Διαδικασία Εγγραφής | Επαλήθευση Κινητού Τηλεφώνου και email',
			'Title': 'Τίτλος',
			'Mr': 'Κος',
			'Mrs': 'Κα',
			'Other': 'Άλλο',
			'First Name': 'Ονομα',
			'Last Name': 'Επίθετο',
			'Mobile Phone': 'Κινητό Τηλέφωνο',
			'Invalid mobile number': 'Μη έγκυρο νούμερο',
			'I want to receive informational messages from the SNF when my application is approved.': 'Θέλω να λάβω ενημερωτικά μηνύματα από το ΙΣΝ όταν εγκριθεί η αίτησή μου.',
			// 'I agree to the Terms of Use' : 'Συμφωνώ με τους Όρους Χρήσης'
			'I agree to the ': 'Συμφωνώ με τους ',
			'Terms of Use': 'Όρους Χρήσης',
			'Clear': 'Καθαρισμός',
			'Please verify that you are not a robot': 'Επαληθεύστε ότι δεν είστε ρομπότ',
			'Invalid characters for the selected language': 'Μη έγκυροι χαρακτήρες για την επιλεγμένη γλώσσα',
			'Only Greek ,up to 50 characters': 'Μόνο Ελληνικά, μέχρι 50 χαρακτήρες',
			'Only English, up to 50 characters': 'Μόνο Αγγλικά, μέχρι 50 χαρακτήρες',
			'Only Greek ,up to 70 characters': 'Μόνο Ελληνικά, μέχρι 70 χαρακτήρες',
			'Only English, up to 70 characters': 'Μόνο Αγγλικά, μέχρι 70 χαρακτήρες',
			'Up to 100 Latin characters': 'Μέχρι 100 Λατινικοί χαρακτήρες',
			'Password from Mobile': 'Κωδικός επαλήθευσης Κινητού Τηλεφώνου',
			'Password from Email': 'Κωδικός επαλήθευσης email',
			'Your Applications': 'Οι Αιτήσεις σας',
			"New member?":"Νέο μέλος?",
			"Forgot password?":"Ξεχάσατε το συνθηματικό;",
			"Reset it":"Επανέκδοση",
			"Sign up":"Εγγραφή",
			"Only Greek/English up to 50 characters":"Μόνο Ελληνικά/Αγγλικά μέχρι 50 χαρακτήρες",
			"Only Greek/English up to 70 characters":"Μόνο Ελληνικά/Αγγλικά μέχρι 70 χαρακτήρες",
			"Email, up to 100 Latin characters":"Email,μέχρι 100 λατινικούς χαρακτήρες",
			"I want to receive informational messages from the SNF...":"Επιθυμώ να λαμβάνω ενημερωτικά μηνύματα από το ΙΣΝ...",
			"I agree to the":"Συμφωνώ με τους",
			"Account Registration":"Δημιουργία λογαριασμού",
			"Grant application portal":"Πύλη αίτησης δωρεών",
			"First-time applicant?":"Κάνετε αίτηση για πρώτη φορά;",
			"Create an account":"Δημιουργήστε λογαριασμό",
			"Account Verification":"Επαλήθευση λογαριασμού",
			"Wrong password or email":"Λάθος κωδικός ή email",
			"Verification failed!":"Αποτυχία επαλήθευσης!",
			"Registration failed!":"Η εγγραφή απέτυχε!",
			"Mobile Verification Code":"Κωδικός επιβεβαίωσης κινητού",
			"Verification Code from email":"Κωδικός επιβεβαίωσης από mail"
		},
		en: {
			"Not Found": "Email not found.",
			'reset_success': 'Password reset successful. Please proceed to login.',
			'request_new_pass_success': 'The 6 digit code was successfully send to your email. If you cannot find this email, please check SPAM or JUNK folders in your email provider.',
			'msg.login_notfound': 'Incorrect Login Credentials',
			"30for30Title": "30 for 30 : Next Gen Grants"
		}
	},
	[Namespaces.PAGE_HOME]: {
		el: {},
		en: {}
	},
	[Namespaces.NOT_FOUND]: {
		el: {
			'The page you are looking was moved, removed, renamed, or might never existed!': 'Η σελίδα που ψάχνετε μετακινήθηκε, αφαιρέθηκε, μετονομάστηκε ή μπορεί να μην υπήρξε ποτέ!',
			'Back To Home': 'Επιστροφή στην Αρχική',
			'Page Not Found': 'Η σελίδα δεν βρέθηκε',
		},
		en: {}
		,
	},
	[Namespaces.PAGE_APPLICATIONS]:	{
		el: {
			'SNF Grant Portal | Your Applications' : 'Πύλη Δωρεών ΙΣΝ | Οι Αιτήσεις σας',
			'New application' : 'Νέα αίτηση',
			'Logout' : 'Έξοδος',
			'Request history' : 'Ιστορικό αιτήσεων',
			'The application has been successfully registered':'Η αίτηση έχει καταχωρηθεί επιτυχώς',
			"SNF Grant portal": "Πύλη Δωρεών ΙΣΝ",
			"Organization and request details": "Στοιχεία Οργανισμού και Αιτήματος",

			"Tax Identification Number": "Αριθμός Φορολογικού Μητρώου",
			"Organization details": "Στοιχεία οργανισμού",
			"Representative": "Νόμιμος εκπρόσωπος",
			"Request details": "Λεπτομέρειες αιτήματος",
			"Done": "Ολοκληρώθηκε",

			"Reset": "Επαναφορά",
			"Back": "Πισω",
			"Submit": "Υποβολη",
			"Next": "Επομενο",
			"First we need the TIN description": "Συμπληρώστε τον Αριθμό Φορολογικού Μητρώου (ΑΦΜ) του οργανισμού που εκπροσωπείτε. Αν έχει ξαναγίνει αίτηση για τον οργανισμό σας, τα στοιχεία θα συμπληρωθούν αυτόματα στο επόμενο βήμα.",
			"TIN": "ΑΦΜ",
			"General information": "Γενικές πληροφορίες",

			"Country": "Χώρα",
			"Organization name": "Όνομα οργανισμού",
			"Organization mission": "Αποστολή/βασικοί τομείς ενασχόλησης",
			"Authority under which nonprofit status is registered": "Εγγεγραμμένος ως",
			"Date established": "Ημερομηνία ίδρυσης",
			"Fiscal sponsor (if applicable)": "Φορέας διαχείρισης",

			"Address & contact information": "Διεύθυνση και στοιχεία επικοινωνίας",
			"Address Line 1": "Διεύθυνση (Γραμμή 1)",
			"Address Line 2": "Διεύθυνση (Γραμμή 2)",
			"City": "Πόλη",
			"State/Prefecture": "Περιφέρεια/Νομός",
			"Zip code": "Τ.Κ.",
			"Office phone": "Τηλέφωνο",
			"Email": "Email",

			"Organization website & social media(if applicable)": "Ιστότοπος οργανισμού & κοινωνικά δίκτυα",
			"Website": "Ιστότοπος",
			"Facebook": "Facebook",
			"X": "X",
			"Instagram": "Instagram",
			"Other social network": "Άλλα κοινωνικά δίκτυα",
			"Mobile phone must contain only numbers and an optional leading +":"Το κινητό πρέπει να περιέχει μόνο αριθμούς και τον διεθνή κωδικό της χώρας σας",
			"I affirm that I am authorized": "Βεβαιώνω ότι είμαι εξουσιοδοτημένος/η να ενεργώ εκ μέρους του οργανισμού",
			"Organization legal representative": "Νόμιμος εκπρόσωπος οργανισμού",
			"Phone line is required":"Το τηλέφωνο είναι υποχρεωτικό",
			"Title": "Τίτλος",
			"First name": "Όνομα",
			"Last name": "Επίθετο",
			"Position/Title": "Θέση/Τίτλος",
			"Mobile phone": "Κινητό τηλέφωνο",
			"Be sure to include your country code and only numbers":"Βεβαιωθείτε ότι έχετε συμπεριλάβει τον κωδικό της χώρας σας και μόνο αριθμούς",
			"Be sure to include your country code (e.g. +30 for Greece, +1 for the U.S., +33 for France).":
				"Βεβαιωθείτε ότι έχετε συμπεριλάβει τον διεθνή κωδικό (π.χ. +30 για Ελλάδα, +1 για ΗΠΑ, +33 για Γαλλία).",

			"If your organization's legal representative is also the person responsible for the submission of this request, check this box. Otherwise, enter contact information below.":
				"Αν ο νόμιμος εκπρόσωπος του οργανισμού είναι και το άτομο υπεύθυνο για την υποβολή αυτής της αίτησης, επιλέξτε αυτό το κουτί. Διαφορετικά, συμπληρώστε τα στοιχεία επικοινωνίας παρακάτω.",

			"Contact Details (if different from above)":
				"Στοιχεία Επικοινωνίας (αν διαφέρουν από τα παραπάνω)",

			"Be sure to include your country code.":
				"Βεβαιωθείτε ότι έχετε συμπεριλάβει τον διεθνή κωδικό.",
			"Organization information": "Πληροφορίες Οργανισμού",
			"OrgInfoText": "Δώστε μας πληροφορίες όπως πότε ιδρύθηκε ο οργανισμός, ποια η αποστολή και οι δραστηριότητές του, το προσωπικό και τους εθελοντές, καθώς και τον αριθμό των ανθρώπων που εξυπηρετεί.",
			"History": "Ιστορία του οργανισμού (μέγιστο 3,000 χαρακτήρες)",
			"Request description": "Περιγραφή Αιτήματος",
			"RequestDescriptionText": "Παρακαλώ περιγράψτε το αίτημα που υποβάλλει ο οργανισμός σας, τον σκοπό, τους ωφελούμενους, την τοποθεσία υλοποίησης και το χρονοδιάγραμμα.",
			"Purpose of request": "Αναλυτική περιγραφή του σκοπού για τον οποίο ζητάτε επιχορήγηση (μέγιστο 3,000 χαρακτήρες)",
			"AmountLabel": "Αιτούμενο ποσό (Παρακαλώ χρησιμοποιήστε ακέραιους χωρίς κόμματα.)",
			"Currency": "Νόμισμα",
			"CampaignAgreement": "Παρακαλώ επιβεβαιώστε ότι τα αιτούμενα ποσά θα έχουν δαπανηθεί έως τον Ιούνιο 2027 *",
			"FinalNote": "Αφού υποβάλετε, δεν θα μπορείτε να κάνετε αλλαγές. Χρησιμοποιήστε το κουμπί 'Πίσω' για αλλαγές πριν πατήσετε Υποβολή.",
			"Done!": "Ολοκληρώθηκε!",
			"The first stage of your request is complete. Please check your email for instructions for the next step.": "Το πρώτο στάδιο του αιτήματός σας ολοκληρώθηκε. Παρακαλούμε ελέγξτε το email σας για οδηγίες σχετικά με το επόμενο βήμα.",
			"Click here to review your request(s).": "Κάντε κλικ εδώ για να δείτε τις αιτήσεις σας.",
			"Session Timeout": "Λήξη Συνεδρίας",
			"Your time has expired. What would you like to do?": "Ο χρόνος συνεδρίας έχει λήξει. Τι θα θέλατε να κάνετε;",
			"Reset Timer": "Επαναφορά Χρόνου",
			"Exit": "Έξοδος",
			"Note": "Σημείωση: Η διαδικασία αιτήσεων δωρεάς του ΙΣΝ δεν είναι ανοικτή σε ιδιώτες ή εταιρείες με κερδοσκοπικό σκοπό.",
			"TIN is required": "Απαιτείται  ΑΦΜ",
			"TIN must be 9 digits": "Ο ΑΦΜ πρέπει να αποτελείται από 9 ψηφία",

			"Country is required": "Απαιτείται η χώρα",
			"Organization name is required": "Απαιτείται η επωνυμία του οργανισμού",

			"Address Line 1 is required": "Απαιτείται η διεύθυνση (Γραμμή 1)",
			"City is required": "Απαιτείται η πόλη",
			"State/Prefecture is required": "Απαιτείται η Περιφέρεια/Νομός",
			"Zip is required": "Απαιτείται ο Ταχυδρομικός Κώδικας",

			"Office phone is required": "Απαιτείται το τηλέφωνο γραφείου",
			"Invalid email": "Μη έγκυρο email",
			"Email is required": "Απαιτείται το email",

			"Organization mission is required": "Απαιτείται η αποστολή του οργανισμού",
			"Max 3000 characters": "Μέγιστο όριο 3000 χαρακτήρων",

			"Registered as per is required": "Απαιτείται η σχετική εγγραφή",
			"Date Established is required": "Απαιτείται η ημερομηνία ίδρυσης",

			"You must confirm that you are authorized": "Πρέπει να επιβεβαιώσετε ότι είστε εξουσιοδοτημένοι",

			"Title is required": "Απαιτείται ο τίτλος",
			"First name is required": "Απαιτείται το όνομα",
			"Last name is required": "Απαιτείται το επώνυμο",
			"Position/Title is required": "Απαιτείται η θέση/τίτλος",
			"Fixed phone line is required": "Απαιτείται σταθερό τηλέφωνο",


			"History and mission is required": "Απαιτείται ιστορικό και αποστολή",
			"Request description is required": "Απαιτείται η περιγραφή του αιτήματος",

			"Amount must be a number": "Το ποσό πρέπει να είναι αριθμός",
			"Amount must be an integer": "Το ποσό πρέπει να είναι ακέραιος αριθμός",
			"Amount must be greater than 0": "Το ποσό πρέπει να είναι μεγαλύτερο από 0",
			"Amount is required": "Απαιτείται το ποσό",

			"Currency is required": "Απαιτείται το νόμισμα",

			"You must confirm that funding will be expended by June 2027":
				"Πρέπει να επιβεβαιώσετε ότι η χρηματοδότηση θα έχει δαπανηθεί έως τον Ιούνιο 2027",
			"Step":"Βήμα",
			"Reset timer":"Επαναφορά χρόνου",
			'File upload':"Επισύναψη Δικαιολογητικών",
			"Drop your files here":"Σύρετε τα αρχεία σας εδώ",
			'Otherwise press the button to choose a file from your device':' Εναλλακτικά πατήστε το κουμπί για να επιλέξετε από τη συσκευή σας.',
			'Up to 20 files 10MB size each':' Έως 20 αρχεία μεγέθους 10MB το καθένα',
			'Choose files':'Επιλέξτε Αρχεία',
			'File Name':'Όνομα Αρχείου',
			'Date - Hour':'Ημερομηνία - Ώρα',
			"Required":"Υποχρεωτικό πεδίο",
			"At least 8 characters": "Τουλάχιστον 8 χαρακτήρες",
			"Up to 30 characters": "Έως 30 χαρακτήρες",
			"At least one lowercase letter": "Τουλάχιστον ένα πεζό γράμμα",
			"At least one uppercase letter": "Τουλάχιστον ένα κεφαλαίο γράμμα",
			"At least one number": "Τουλάχιστον έναν αριθμό",
			"At least one special character": "Τουλάχιστον έναν ειδικό χαρακτήρα",
			"Password changed successfully": "Ο κωδικός άλλαξε επιτυχώς",
			"Password received via email": "Συνθηματικό που λάβατε με Email",
			"Your password must contain at least 8 characters and include at least one lowercase letter, one uppercase letter, one number, and one special character.":
				"Το συνθηματικό σας πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες και να περιλαμβάνει τουλάχιστον ένα πεζό και ένα κεφαλαίο γράμμα, έναν αριθμό και έναν ειδικό χαρακτήρα.",
			"New Password": "Νέο Συνθηματικό",
			"Repeat New Password": "Επανάληψη Νέου Συνθηματικού",
			"Continue": "Συνέχεια",
			"Home": "Αρχική",
			"Reset Password":"Επαναφορά Συνθηματικού",
			"Password":"Συνθηματικό",
			"Submission failed":"Η υποβολή απέτυχε",
			"Failed change password":"Η αλλαγή κωδικού απέτυχε",
			"File sent!":"Το αρχείο στάλθηκε επιτυχώς!",
			"Failed to sent the file":"Αποτυχία αποστολής αρχείου",
			"Failed loading requests":"Αποτυχία φόρτωσης αιτήσεων",
			"How did you learn for us?":"Πως μάθατε για εμάς;",
			"Only Greek characters are allowed":"Μόνο ελληνικοί χαρακτήρες επιτρέπονται",
			"Only Latin characters are allowed":"Μόνο λατινικοί χαρακτήρες επιτρέπονται",
			"Organization name(in greek characters)":"Όνομα οργανισμού(με ελληνικούς χαρακτήρες)",
			"Organization name(in latin characters)":"Όνομα οργανισμού(με λατινικούς χαρακτήρες)",
			"First name(in greek characters)":"Όνομα(με ελληνικούς χαρακτήρες)",
			"First name(in latin characters":"Όνομα(με λατινικούς χαρακτήρες)",
			"Last name(in greek characters)":"Επίθετο(με ελληνικούς χαρακτήρες)",
			"Last name(in latin characters":"Επίθετο(με λατινικούς χαρακτήρες)",
			"Unable to change password!":"Αδυναμία αλλαγής κωδικού!"
		},
		en: {
			"First we need the TIN description": "Please provide the Tax Identification Number (TIN) of the organization you represent. If a request has ever previously been submitted for your organization, organizational details will automatically populate in the next step for your review.",
			"TIN": "TIN",
			"General Info": "General Info",

			"Country": "Country",
			"Organization name": "Organization name",
			"Organization Mission": "Organization Mission",
			"Registered As Per": "Registered As Per",
			"Date Established": "Date Established",
			"Fiscal Sponsor (if exists)": "Fiscal Sponsor (if exists)",

			"Address & contact": "Address & contact",
			"Address Line 1": "Address Line 1",
			"Address Line 2": "Address Line 2",
			"City": "City",
			"State/Prefecture": "State/Prefecture",
			"Zip": "Zip",
			"Office Phone number": "Office Phone number",
			"Email": "Email",

			"Organization Website & Social Media": "Organization Website & Social Media",
			"Website": "Website",
			"Facebook": "Facebook",
			"X": "X",
			"Instagram": "Instagram",
			"Other Social Network": "Other Social Network",

			"I affirm that I am authorized": "I affirm that I am authorized to act on behalf of my organization*",
			"Organization Legal Representative": "Organization Legal Representative",

			"Title": "Title",
			"First name": "First name",
			"Last name": "Last name",
			"Position/Title": "Position/Title",
			"Fixed phone line": "Fixed phone line",
			"Mobile phone line": "Mobile phone line",
			"Be sure to include your country code (e.g. +30 for Greece, +1 for the U.S., +33 for France).":
				"Be sure to include your country code (e.g. +30 for Greece, +1 for the U.S., +33 for France).",

			"If your organization's legal representative is also the person responsible for the submission of this request, check this box. Otherwise, enter contact information below.":
				"If your organization's legal representative is also the person responsible for the submission of this request, check this box. Otherwise, enter contact information below.",

			"Contact Details (if different from above)":
				"Contact Details (if different from above)",
			"Be sure to include your country code.":
				"Be sure to include your country code.",
			"Organization information": "Organization information",
			"OrgInfoText": "Please share information about your organization’s mission and activities, when it was established, and who it serves.",
			"History": "History(max 3,000 characters)",
			"Request Description": "Request Description",
			"RequestDescriptionText": "Please share specifics of the request your organization is submitting, including its purpose, intended beneficiaries, where the grant would be used, and the overall implementation timeline.",
			"Purpose of request": "A detailed description of the purpose for which you are requesting a grant (max 3,000 characters)",
			"AmountLabel": "Amount (Please use integers without commas)",
			"Currency": "Currency",
			"CampaignAgreement": "Please confirm that the requested grant funds would be expended by June 2027 *",
			"FinalNote": "Once you submit, you will not be able to make changes. Please use the Back button to make any necessary changes before clicking Submit.",
			"Done!": "Done!",
			"The first stage of your request is complete. Please check your email for instructions for the next step.": "The first stage of your request is complete. Please check your email for instructions for the next step.",
			"Click here to review your request(s).": "Click here to review your request(s).",
			"Session Timeout": "Session Timeout",
			"Your time has expired. What would you like to do?": "Your time has expired. What would you like to do?",
			"Reset Timer": "Reset Timer",
			"Exit": "Exit",
			"Note": "Note: SNF’s grant request process is not open to individuals or for-profit companies."
		}
		},

}

export default locales